import Vue from 'vue';
import RegisterForm from "../vue/RegisterForm.vue"

function initRegister() {
    if (document.querySelector('.register_container')) {
        new Vue({
            name: 'RegisterFormRoot',
            el: '.register_container',
            components: {
                RegisterForm,
            },
            data: {
            },
            methods: {
            },
            mounted() { }
        });
    }
}

document.addEventListener("DOMContentLoaded", initRegister);
window.addEventListener("Pageeditor:insert", initRegister);
window.addEventListener("Pageeditor:change", initRegister);
